module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_9006.bb548077.png";